import React from 'react'
import { SignUpForm } from '../forms'

export function SignUpModal({ siteData, showSignUpModal, setShowSignUpModal }) {
    return <SignUpForm {...{ siteData, showSignUpModal, setShowSignUpModal }} />
}

export default SignUpModal
